// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__3b8O7","withOverflow":"List_withOverflow__179BC"};